import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d="M8.38428 8.31748C8.54084 7.83505 8.82764 7.40572 9.21322 7.07619C9.59879 6.74667 10.0685 6.53013 10.5694 6.45065C11.0704 6.37118 11.5832 6.4317 12.0518 6.62569C12.5205 6.81969 12.9263 7.13968 13.2245 7.54997C13.5227 7.96025 13.7013 8.44485 13.7412 8.95048C13.781 9.45611 13.6802 9.96306 13.45 10.415C13.2197 10.8669 12.8694 11.2461 12.437 11.5111C12.0045 11.7762 11.5072 11.9165 11 11.9165V12.8335M11 19.25C6.44365 19.25 2.75 15.5563 2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 15.5563 15.5563 19.25 11 19.25ZM11.0457 15.5833V15.675L10.9543 15.6752V15.5833H11.0457Z"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
)

export const CircleHelp: React.FC<IconProps> = ({color, size, ...props}) => (
    <IconWrapper {...{...props, size, color}} renderIcon={renderIcon}
                 viewBox={`0 0 ${parseInt(size)} ${parseInt(size)}`}/>
)
